/* @flow */

// http://stackoverflow.com/a/16270434/46040
export default function isElementInViewport(el: HTMLElement) {
  const rect = el.getBoundingClientRect();

  return rect.bottom > 0 &&
    rect.right > 0 &&
    rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
    rect.top < (window.innerHeight || document.documentElement.clientHeight);
}



// WEBPACK FOOTER //
// ./src/utils/isElementInViewport.js